/* eslint-disable no-template-curly-in-string, filenames/match-regex */
import Cookies from 'react-cookies';
import { COOKIES } from '../../../brands/default/constants';
import { URLKICKBOX, URLSUBSCRIBE } from '../../../brands/default/services';
import { trackEvent } from '../../../helpers/analytics';
import httpCommonHeaders from '../../../helpers/httpCommonHeaders';
import { redirectToURL, parseWowcherPath } from '../../../helpers/url';
import { getUserLocationShortName } from '../../../helpers/user';
import axios from '../../_generic/axiosSplunk/axiosSplunk';

export const redirectToWPSUrl = (redirectUrl, location, router) => {
  let url = redirectUrl;

  if (redirectUrl?.includes('${location}')) {
    url = redirectUrl.replace('${location}', location);
  }
  redirectToURL(url, router);
};

export const redirectToLocationPage = ({ originalUrl, location, router }) => {
  const { pathArray } = parseWowcherPath(originalUrl);
  const url = originalUrl.replace(pathArray[1], location);
  redirectToURL(url, router);
};

export const trackEmailEvent = (newEmail) => {
  trackEvent('completed_subscription');
  if (newEmail) {
    trackEvent('newEmailEvent');
  } else {
    trackEvent('repeatEmailEvent');
  }
};

export const setAxiosConfig = async (email, location) => {
  const specialLocation = `${location || getUserLocationShortName()}`;

  return axios({
    data: {
      email,
      location: specialLocation,
      subscriptionSource: Cookies.load(COOKIES.userSource) || '',
    },
    headers: httpCommonHeaders(),
    method: 'post',
    url: URLSUBSCRIBE,
    validateStatus: false,
    withCredentials: true,
  });
};

export const checkKickbox = async (email) => {
  try {
    return await axios({
      method: 'get',
      url: URLKICKBOX(email),
    });
  } catch (error) {
    console.error(error);

    return null;
  }
};
